import configureStore from 'store/configureStore';
import { applicationInitialized } from 'store/modules/application'
import * as API from 'api';
import axios from 'axios'
import { Authentication, User } from '.';
import { IHttpRequest } from './utils';
import { authenticationActionHandler } from './authentication';
import { configureNavigation } from './navigation';


// Application Global State
export interface IApplicationState {
    store: any,
    history: any,
    httpRequest: IHttpRequest;
}

//Async Calls
export const httpRequest = axios as IHttpRequest;

let isInitialized = false;
/** Initialize application and setup all dependencies 
 * returns application root object
 */
export const initialize = (): IApplicationState => {
    if (isInitialized) {
        throw new Error("Application Initialize Can Only Be Called Once!");
    }
    return onCreateApplication();
}

/**  Create Application */
function onCreateApplication(): IApplicationState {

    //Redux Store
    const store = configureStore();
    //Navigation
    const history = configureNavigation(store.dispatch);

    // Authentication
    const authStorage = getAuthenticationStore(store);
    API.ConfigureFetchAuthentication(httpRequest, authStorage);

    //ToDo: review if below is a duplicate to authenticate(result)
    const handler = authenticationActionHandler(store.dispatch);
    API.Auth0.scheduleTokenRenewal(authStorage.getAccessTokenExpiry(), handler);
    if (authStorage.isAuthenticated()) {
        User.loadUserInformation(store.dispatch);
    }

    isInitialized = true;
    store.dispatch(applicationInitialized())

    return { store, history, httpRequest };
}

/** Creates interface for authentication flags in store */
function getAuthenticationStore(store) {
    return {
        isAuthenticated: () => Authentication.isAuthenticated(store.getState() as any),
        getAccessToken: () => Authentication.getAccessToken(store.getState() as any),
        getUserAuth0Id: () => Authentication.getUserId(store.getState() as any),
        getAccessTokenExpiry: () => Authentication.getAccessTokenExpiry(store.getState() as any)
    }
}



// WEBPACK FOOTER //
// ./src/application/initialize.ts